import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from 'react-router';
import { NavigationFunction as RootNavigation, Pages } from "../../../../Navigation/Routers/root"
import { colors, frames, glyphs, useMediaQuery } from "../../../../Styles";
import { PageHeader, NewSelect, ArchivedReportCard, Button, NewInput, NewInputHandles } from "../../../../Components";
import { ButtonTypes, NewFieldStyles } from "../../../../Definitions";

// TODO 
import { ArchivedReportData } from "../../../../Assets/TestData/reports";
import CardsView, { SortOption } from "../../../../Assets/TestData/cardsView";

export default function Archive() {
  const {t} = useTranslation()
  const navigator = useNavigate()
  const [showReport, setShowReport] = useState<number | undefined>(undefined)
  
  const searchRef = useRef<NewInputHandles>(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [sortBy, setSortBy] = useState<SortOption>("id")
  const [showfilterSearchList, setShowfilterSearchList] = useState<boolean>(false)

  // Mediaqueries
  const pageHeaderResponsive = useMediaQuery(`(min-width: 550px) and (max-width: 1150px)`);
  const mobileXs = useMediaQuery(`(max-width: 550px)`);
  
  // Handle report click
  const onReportSelect = (id: number) => {
    setShowReport(id);
    
    const selectedArchivedReportData = ArchivedReportData.find(report => report.reportId === id);
    if (selectedArchivedReportData) {
      RootNavigation(navigator, Pages.reports, Pages.report, true, { selected: selectedArchivedReportData?.reportId });
    }
  };

  // Filter options
  const filterByOptions = [   
    { label: t("reportPages.archive.filterByNumber", {defaultValue: "Report Number"}), id: "id" as SortOption},
    { label: t("reportPages.archive.filterByName", {defaultValue: "Report Name Alphabetical"}), id: "name" as SortOption},
  ]

  // #region | Filter/search fields
  const filterSearchList = (
    <div style={{  display: "flex", flexDirection: mobileXs ? "column" : "row", gap: "10px", zIndex: "10", backgroundColor: mobileXs ? colors.greyDarkPrimary : "", padding: mobileXs ? "20px" : "0px", borderRadius: mobileXs ? "10px" : "0px", boxShadow: mobileXs ? "0px 0px 5px 2px"+colors.blackPrimary+"4d" : "none"}}>
      <NewSelect
        onChange={(e) => {if (e?.id === "id" || e?.id === "name") setSortBy(e.id)}} 
        fieldOverrides={{
          fieldStyle: mobileXs ? NewFieldStyles.greyDarkSecondary : NewFieldStyles.greyDarkPrimary, 
          fieldWidth: pageHeaderResponsive? "137.5px" : "280px", 
        }} 
        placeholder={t("filterBy", {defaultValue: "Filter By"})} 
        options={filterByOptions} 
        valueOverrides={{
          defaultValue: filterByOptions.find(opt => opt.id === sortBy)
        }}
      />
      <NewInput
        ref={searchRef}
        onChange={(value: string) => setSearchTerm(value)}
        fieldOverrides={{
          fieldStyle: mobileXs ? NewFieldStyles.greyDarkSecondary : NewFieldStyles.greyDarkPrimary,
          fieldWidth: pageHeaderResponsive? "137.5px" : "280px", 
        }}
        placeholder={t("search", { defaultValue: "search" })}
      />
    </div>
  )
  // #endregion

  return (
    <frames.Page_inner>
      <frames._page_inner_header>
        <div style={{display: "flex", flexDirection: "row", alignItems: "start", justifyContent: "space-between"}}>
          <PageHeader topHeader={t(`menuHeaders.${Pages.reports}`, {defaultValue: "Reports"})} subHeader={t(`menuHeaders.${Pages.archive}`, {defaultValue: "Archive"})}/>
          <div>
            {!mobileXs ? <>{filterSearchList}</>
            : showfilterSearchList ? <>
              <div onClick={() => setShowfilterSearchList(false)} style={{ cursor: "pointer" }}>
                <glyphs.Close size="25px"/>
              </div> 
              <div style={{ position: "absolute", top: "50px", right: "20px", zIndex: "1000" }}>
                {filterSearchList}
              </div>
            </> : 
              <Button content={""} 
                onClick={() => setShowfilterSearchList(true)}
                buttonType={ButtonTypes.textButton}
                startEnhancer={glyphs.Setting({size: "25px"})}
              /> 
            }
          </div>
        </div>
      </frames._page_inner_header>
      <frames._page_inner_content_scroll>
        <CardsView
          data={ArchivedReportData}
          sortBy={sortBy}
          searchTerm={searchTerm}
          card={(report, index) => (
            <ArchivedReportCard key={index} report={report} onCardSelect={onReportSelect} />
          )}
          getName={item => item.name ?? ""}
          getId={item => item.reportId ?? 0}
        />
      </frames._page_inner_content_scroll>
    </frames.Page_inner>
  )
}